import CacheService from '../cache-service';
const axios = require('axios');

class InstagramService extends CacheService {
  getCandidates(queryParams) {
    return axios.get(`/api/instagram/candidates${queryParams}`).then(res => res.data);
  }

  saveCandidates(candidates) {
    return axios.post('/api/instagram/candidates', { candidates }).then(res => res.data);
  } 

  getCandidatesAutoNames(queryParams) {
    return axios.get(`/api/instagram/candidates-auto-names${queryParams}`).then(res => res.data);
  }

  saveCandidatesAutoNames(candidates) {
    return axios.post('/api/instagram/candidates-auto-names', { candidates }).then(res => res.data);
  } 
  
}

const instagramService = new InstagramService();

export default instagramService;